import { render } from "./ModalMoreDetailsGeneric.vue?vue&type=template&id=4a6034c9&scoped=true"
import script from "./ModalMoreDetailsGeneric.vue?vue&type=script&lang=js"
export * from "./ModalMoreDetailsGeneric.vue?vue&type=script&lang=js"

import "./ModalMoreDetailsGeneric.vue?vue&type=style&index=0&id=4a6034c9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a6034c9"]])

export default __exports__